import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fromYourDataDescription: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.from-your-data-description',
		defaultMessage: 'Automatically created using recent data from this project’s issues.',
		description:
			'Description under the "from your data" lozenge explaining how this template was created.',
	},
	catalogTemplateDescription: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.catalog-template-description',
		defaultMessage:
			'We created this template based on the most common intents and issue categories used by IT teams.',
		description: 'Description explaining that this intent template is a global template.',
	},
	summaryLabel: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.summary-label',
		defaultMessage: 'Summary',
		description: 'Label for summary section in the intent templates tooltip.',
	},
	descriptionLabel: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.description-label',
		defaultMessage: 'Description',
		description: 'Label for the description field in the intent template.',
	},
	trainingPhrasesLabel: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.training-phrases-label',
		defaultMessage: 'Training phrases',
		description: 'Label for how many training phrases are in the hovered over intent template.',
	},
	trainingPhrasesNumber: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.training-phrases-number',
		defaultMessage: '{numberOfTrainingPhrases, plural, one {# phrase} other {# phrases}}',
		description: 'Displays the number of training phrases in the hovered over intent template.',
	},
});
